import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

import ScreenshotMode from '../../utilities/screenshot-mode';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 400,
		flexGrow: 1,
		marginLeft: "auto",
		marginRight: "auto",
		borderRadius: "100%",
		position: "relative",
	},
	stepper: {
		background: "transparent",
		justifyContent: "center",
	},
	img: {
		height: 542,
		maxWidth: 400,
		overflow: 'hidden',
		display: 'block',
		width: '100%',
	},
	bttnBack: {
		borderRadius: "100%",
		minWidth: "32px",
		height: "32px",
		backgroundColor: "rgba(0,0,0,0.2)",
		position: "absolute",
		top: "50%",
		left: "2rem",
		boxShadow: "0 0 8px 0 rgba(0,0,0,0.2)",
		"&:hover": {
			backgroundColor: "rgba(0,0,0,0.5)",
		},
	},
	bttnNext: {
		borderRadius: "100%",
		minWidth: "32px",
		height: "32px",
		backgroundColor: "rgba(0,0,0,0.2)",
		position: "absolute",
		top: "50%",
		right: "2rem",
		boxShadow: "0 0 8px 0 rgba(0,0,0,0.2)",
		"&:hover": {
			backgroundColor: "rgba(0,0,0,0.5)",
		},
	},
}));

export default function TextMobileStepper({ stepperImgs }) {
	const classes = useStyles();
	const theme = useTheme();
	const [activeStep, setActiveStep] = React.useState(0);
	const maxSteps = stepperImgs.length;

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleStepChange = (step) => {
        // Hack to disable autoplay when animations are disabled for screenshots;
        // there doesn't appear to achieve this provided by the plugin
        if (!ScreenshotMode.disableAnimation)
    		setActiveStep(step);
	};
	// console.log(activeStep);

	return (
		<div className={classes.root}>
			<AutoPlaySwipeableViews
				axis={'x'}
				index={activeStep}
				onChangeIndex={handleStepChange}
				enableMouseEvents
			>
				{stepperImgs.map((step, index) => (
					<span key={stepperImgs[index].label}>
						{Math.abs(activeStep - index) <= 2  ? (
							<img
								className={classes.img}
								src={stepperImgs[index].imgPath}
								alt={stepperImgs[index].label} />
						) : null
						}
					</span>
				))}
			</AutoPlaySwipeableViews>
			<MobileStepper
				className={classes.stepper}
				steps={maxSteps}
				position="static"
				variant="dots"
				activeStep={activeStep}
				nextButton={
					<Button size="large" onClick={handleNext} disabled={activeStep === maxSteps - 1} className={classes.bttnNext}>
						<span className="hidden">Next</span>
						{theme.direction === 'rtl' ? 
							<KeyboardArrowLeft style={{ color: "#fff" }} viewBox="6 6 12 12" /> : 
							<KeyboardArrowRight style={{ color: "#fff" }} viewBox="6 6 12 12" />}
					</Button>
				}
				backButton={
					<Button size="large" onClick={handleBack} disabled={activeStep === 0} className={classes.bttnBack}>
						<span className="hidden">Previous</span>
						{theme.direction === 'rtl' ? 
							<KeyboardArrowRight style={{ color: "#fff" }} viewBox="6 6 12 12" /> : 
							<KeyboardArrowLeft style={{ color: "#fff" }} viewBox="6 6 12 12" />}
					</Button>
				}
			/>
		</div>
	);
}
